<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" style="width: 100%;" :before-leave="beforeTabLeave">
      <el-tab-pane label="训练计划列表" name="first">
        <div class="main">
            <!-- Right -->
            <div class="main_r">
              <!-- search -->
              <div class="search">
                <div class="search-content">
                  <el-select v-model="queryData.trainPlanClassification" placeholder="训练计划分类">
                    <el-option label="训练计划分类" value="0"></el-option>
                    <el-option
                      v-for="item in aptustwoGvListTrainPlanClassification" :key="item.gv" :label="item.name" :value="item.gv">
                    </el-option>
                  </el-select>
                  <el-input v-model="queryData.trainPlanName"  placeholder="训练计划名称"></el-input>
                  <el-select v-model="queryData.trainPlanDifficulty" placeholder="训练计划难度">
                    <el-option label="训练计划难度" value="0"></el-option>
                    <el-option
                      v-for="item in aptustwoGvListCourseDifficulty" :key="item.gv" :label="item.name" :value="item.gv">
                    </el-option>
                  </el-select>
                  <el-select v-model="queryData.trainPlanType" placeholder="训练计划类型">
                    <el-option label="训练计划类型" value="0"></el-option>
                    <el-option
                      v-for="item in aptustwoGvListTrainPlanType" :key="item.gv" :label="item.name" :value="item.gv">
                    </el-option>
                  </el-select>
                  <el-select v-model="queryData.isHome" placeholder="首页推荐">
                    <el-option label="首页推荐" value="-1"></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                  <el-select v-model="queryData.isBanner" placeholder="Banner推荐">
                    <el-option label="Banner推荐" value="-1"></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                  <el-button type="primary" @click="clickQuery">查询</el-button>
                  <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
                  <el-button type="primary" @click="clickdialogAdd">新增</el-button>
                  <el-button type="success" @click="clickBatchAdd">批量新增</el-button>
                </div>
              </div>
              <!-- search End -->

              <!-- 列表 -->
              <div class="table-container">
                <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
                  <el-table-column prop="id" label="序号" width="80" fixed="left"></el-table-column>
                  <el-table-column prop="trainPlanClassification" label="计划分类" width="100">
                    <template slot-scope="props">
                      {{props.row.trainPlanClassification}}周
                    </template>
                  </el-table-column>
                  <el-table-column prop="trainPlanTypeUi" label="计划类型" width="120"></el-table-column>
                  <el-table-column prop="trainPlanWeekNum" label="每周训练次数" width="120">
                    <template slot-scope="props">
                      {{props.row.trainPlanWeekNum}}次
                    </template>
                  </el-table-column>
                  <el-table-column prop="trainPlanTime" label="计划时长" width="100">
                    <template slot-scope="props">
                      {{props.row.trainPlanTime}}秒
                    </template>
                  </el-table-column>
                  <el-table-column prop="trainPlanName" label="计划名称" width="180"></el-table-column>
                  <el-table-column prop="" label="列表封面" width="100">
                    <template v-slot="scope">
                      <el-image
                        v-if="scope.row.trainPlanIconUi"
                        style="width: 48px; height: 48px"
                        :src="scope.row.trainPlanIconUi"
                        :preview-src-list="[scope.row.trainPlanIconUi]"
                        fit="cover">
                      </el-image>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="详情页封面" width="110">
                    <template v-slot="scope">
                      <el-image
                        v-if="scope.row.trainPlanIconDetailsUi"
                        style="width: 48px; height: 48px"
                        :src="scope.row.trainPlanIconDetailsUi"
                        :preview-src-list="[scope.row.trainPlanIconDetailsUi]"
                        fit="cover">
                      </el-image>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="Banner封面" width="110">
                    <template v-slot="scope">
                      <el-image
                        v-if="scope.row.trainPlanIconBannerUi"
                        style="width: 48px; height: 48px"
                        :src="scope.row.trainPlanIconBannerUi"
                        :preview-src-list="[scope.row.trainPlanIconBannerUi]"
                        fit="cover">
                      </el-image>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="trainPlanDifficultyUi" label="计划难度" width="100"></el-table-column>
                  <el-table-column prop="isHome" label="首页推荐" width="100">
                    <template slot-scope="props">
                      <span v-if="props.row.isHome == 0">否</span>
                      <span v-if="props.row.isHome == 1">是</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isBanner" label="Banner推荐" width="110">
                    <template slot-scope="props">
                      <span v-if="props.row.isBanner == 0">否</span>
                      <span v-if="props.row.isBanner == 1">是</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
                  <el-table-column prop="Operation" label="操作" width="150" fixed="right">
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickdialogEdit(scope.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                        <el-link :underline="false" type="danger" icon="el-icon-delete" class="mr12" @click="ClickDelete(scope.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="安排周日程" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-view" class="mr12" @click="gotoWebTwoTrainPlanDatabaseSub(scope.row)"></el-link>
                      </el-tooltip>
<!--                    <el-link :underline="false" type="primary" class="mr12" @click="clickdialogEdit(scope.row)">1.编辑</el-link>
                    <el-link :underline="false" type="danger" class="mr12" @click="ClickDelete(scope.row)">2.删除</el-link>
                    <el-link :underline="false" type="primary" class="mr12" @click="gotoWebTwoTrainPlanDatabaseSub(scope.row)">3.安排周日程</el-link> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <!-- 分页 -->
              <div class="mt20">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="page_no"
                  :page-sizes="[5, 10, 15, 20]"
                  :page-size="page_size"
                  layout="prev, pager, next, sizes, jumper "
                  :total="dataListnum">
                </el-pagination>
              </div>
              <!-- 分页 End -->
            </div>
            <!-- Right End -->

            <!---------------------- 以下是弹框内容 ---------------------->
            <!-- 新增计划 -->
            <el-dialog title="添加计划" :visible.sync="dialogAdd" width="35%" class="newAdd" :close-on-click-modal="false" v-loading="uploadLoading">
              <div class="addUser_body">
                <el-form ref="userMsg" :model="addData" label-width="150px">
                  <el-form-item label="训练计划分类" :required=true>
                    <el-select v-model="addData.trainPlanClassification" placeholder="训练计划分类">
                      <el-option
                        v-for="item in aptustwoGvListTrainPlanClassification" :key="item.gv" :label="item.name" :value="item.gv">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="训练计划类型" :required=true>
                    <el-select v-model="addData.trainPlanType" multiple placeholder="训练计划类型">
                      <el-option
                        v-for="item in aptustwoGvListTrainPlanType" :key="item.gv" :label="item.name" :value="item.gv">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="训练计划难度" :required=true>
                    <el-select v-model="addData.trainPlanDifficulty" placeholder="训练计划难度">
                      <el-option
                        v-for="item in aptustwoGvListCourseDifficulty" :key="item.gv" :label="item.name" :value="item.gv">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="训练计划名称" :required=true>
                    <el-input v-model="addData.trainPlanName" placeholder="请输入训练计划名称"></el-input>
                  </el-form-item>
                  <el-form-item label="列表封面" :required=true>
                    <el-upload
                      class="cover-uploader"
                      :action="''"
                      :http-request="handleAddTrainPlanIconUpload"
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true">
                      <img v-if="addData.trainPlanIconUi || addData.trainPlanIcon" :src="addData.trainPlanIconUi || getImageUrl(addData.trainPlanIcon)" class="cover-image">
                      <i v-else class="el-icon-plus cover-uploader-icon"></i>
                    </el-upload>
                    <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                  </el-form-item>
                  <el-form-item label="详情页封面" :required=true>
                    <el-upload
                      class="cover-uploader"
                      :action="''"
                      :http-request="handleAddTrainPlanIconDetailsUpload"
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true">
                      <img v-if="addData.trainPlanIconDetailsUi || addData.trainPlanIconDetails" :src="addData.trainPlanIconDetailsUi || getImageUrl(addData.trainPlanIconDetails)" class="cover-image">
                      <i v-else class="el-icon-plus cover-uploader-icon"></i>
                    </el-upload>
                    <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                  </el-form-item>
                  <el-form-item label="Banner封面" :required=true>
                    <el-upload
                      class="cover-uploader"
                      :action="''"
                      :http-request="handleAddTrainPlanIconBannerUpload"
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true">
                      <img v-if="addData.trainPlanIconBannerUi || addData.trainPlanIconBanner" :src="addData.trainPlanIconBannerUi || getImageUrl(addData.trainPlanIconBanner)" class="cover-image">
                      <i v-else class="el-icon-plus cover-uploader-icon"></i>
                    </el-upload>
                    <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                  </el-form-item>
                  <el-form-item label="每周训练次数" :required=true>
                    <el-input v-model="addData.trainPlanWeekNum" placeholder="请输入每周训练次数">
                      <template slot="append">
                        <span style="width: 100px; display: inline-block;text-align: center;">次</span>
                      </template>
                    </el-input>
                  </el-form-item>
<!--                  <el-form-item label="训练计划时长(秒)" :required=true>
                    <el-input v-model="addData.trainPlanTime" placeholder="请输入训练计划时长"></el-input>
                  </el-form-item> -->
                  <el-form-item label="训练计划简介" :required=true>
                    <el-input type="textarea" v-model="addData.trainPlanInfo" placeholder="请输入训练计划简介"></el-input>
                  </el-form-item>
                  <el-form-item label="首页推荐" :required=true>
                    <el-select v-model="addData.isHome" placeholder="首页推荐">
                      <el-option label="否" value="0"></el-option>
                      <el-option label="是" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Banner推荐" :required=true>
                    <el-select v-model="addData.isBanner" placeholder="Banner推荐">
                      <el-option label="否" value="0"></el-option>
                      <el-option label="是" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="推荐标题" :required=true>
                    <el-input v-model="addData.bannerTitle" placeholder="请输入推荐标题"></el-input>
                  </el-form-item>
                  <el-form-item label="推荐描述" :required=true>
                    <el-input type="textarea" v-model="addData.bannerDescription" placeholder="请输入推荐描述"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="TrainPlanDatabaseInsert()" >确 认</el-button>
                <el-button @click="dialogAdd = false">取 消</el-button>
              </div>
            </el-dialog>
            <!-- 新增计划 End -->

            <!-- 编辑计划 -->
            <el-dialog title="编辑计划" :visible.sync="dialogEdit" width="35%" class="newAdd" :close-on-click-modal="false" v-loading="uploadLoading">
              <div class="addUser_body">
                <el-form ref="userMsg" :model="editData" label-width="150px">
                  <el-form-item label="训练计划类型" :required=true>
                    <el-select v-model="editData.trainPlanType" multiple placeholder="训练计划类型">
                      <el-option
                        v-for="item in aptustwoGvListTrainPlanType" :key="item.gv" :label="item.name" :value="item.gv">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="训练计划难度" :required=true>
                    <el-select v-model="editData.trainPlanDifficulty" placeholder="训练计划难度">
                      <el-option
                        v-for="item in aptustwoGvListCourseDifficulty" :key="item.gv" :label="item.name" :value="item.gv">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="训练计划名称" :required=true>
                    <el-input v-model="editData.trainPlanName" placeholder="请输入训练计划名称"></el-input>
                  </el-form-item>
                  <el-form-item label="列表封面" :required=true>
                    <el-upload
                      class="cover-uploader"
                      :action="''"
                      :http-request="handleEditTrainPlanIconUpload"
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true">
                      <img v-if="editData.trainPlanIconUi || editData.trainPlanIcon" :src="editData.trainPlanIconUi || getImageUrl(editData.trainPlanIcon)" class="cover-image">
                      <i v-else class="el-icon-plus cover-uploader-icon"></i>
                    </el-upload>
                    <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                  </el-form-item>
                  <el-form-item label="详情页封面" :required=true>
                    <el-upload
                      class="cover-uploader"
                      :action="''"
                      :http-request="handleEditTrainPlanIconDetailsUpload"
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true">
                      <img v-if="editData.trainPlanIconDetailsUi || editData.trainPlanIconDetails" :src="editData.trainPlanIconDetailsUi || getImageUrl(editData.trainPlanIconDetails)" class="cover-image">
                      <i v-else class="el-icon-plus cover-uploader-icon"></i>
                    </el-upload>
                    <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                  </el-form-item>
                  <el-form-item label="Banner封面" :required=true>
                    <el-upload
                      class="cover-uploader"
                      :action="''"
                      :http-request="handleEditTrainPlanIconBannerUpload"
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true">
                      <img v-if="editData.trainPlanIconBannerUi || editData.trainPlanIconBanner" :src="editData.trainPlanIconBannerUi || getImageUrl(editData.trainPlanIconBanner)" class="cover-image">
                      <i v-else class="el-icon-plus cover-uploader-icon"></i>
                    </el-upload>
                    <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                  </el-form-item>
                  <el-form-item label="每周训练次数" :required=true>
                    <el-input v-model="editData.trainPlanWeekNum" placeholder="请输入每周训练次数">
                      <template slot="append">
                        <span style="width: 100px; display: inline-block;text-align: center;">次</span>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="训练计划时长" :required=true>
                    <el-input v-model="editData.trainPlanTime" placeholder="请输入训练计划时长">
                      <template slot="append">
                        <span style="width: 100px; display: inline-block;text-align: center;">秒</span>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="训练计划简介" :required=true>
                    <el-input type="textarea" v-model="editData.trainPlanInfo" placeholder="请输入训练计划简介"></el-input>
                  </el-form-item>
                  <el-form-item label="首页推荐" :required=true>
                    <el-select v-model="editData.isHome" placeholder="首页推荐">
                      <el-option label="否" value="0"></el-option>
                      <el-option label="是" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Banner推荐" :required=true>
                    <el-select v-model="editData.isBanner" placeholder="Banner推荐">
                      <el-option label="否" value="0"></el-option>
                      <el-option label="是" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="推荐标题" :required=true>
                    <el-input v-model="editData.bannerTitle" placeholder="请输入推荐标题"></el-input>
                  </el-form-item>
                  <el-form-item label="推荐描述" :required=true>
                    <el-input type="textarea" v-model="editData.bannerDescription" placeholder="请输入推荐描述"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="TrainPlanDatabaseUpdate()" >确 认</el-button>
                <el-button @click="dialogEdit = false">取 消</el-button>
              </div>
            </el-dialog>
            <!-- 编辑计划 End -->

            <!-- 删除 -->
            <el-dialog title="操作确认" :visible.sync="dialogDel" width="20%" class="confirmDel">
              <div class="confirmMsg">确定删除？</div>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="TrainPlanDatabaseDelete" >确 定</el-button>
                <el-button @click="dialogDel = false">取 消</el-button>
              </div>
            </el-dialog>
            <!-- 删除 End -->

            <!-- 批量新增弹窗 -->
            <el-dialog title="批量新增训练计划" :visible.sync="dialogBatchAdd" fullscreen class="batch-dialog" :close-on-click-modal="false">
              <div class="batch-add-container">
                <div class="batch-toolbar">
                  <el-button type="primary" @click="addBatchRow" icon="el-icon-plus">添加一行</el-button>
                  <el-button type="warning" @click="clearBatchData" icon="el-icon-delete">清空</el-button>
                  <span class="batch-tip">提示：表格支持直接编辑，必填字段不能为空</span>
                </div>

                <el-table :data="batchData" border stripe class="batch-table" max-height="calc(100vh - 220px)">
                  <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>

                  <el-table-column label="训练计划分类(周)" width="150">
                    <template slot="header">
                      <span class="required-field">训练计划分类(周)</span>
                    </template>
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.trainPlanClassification" placeholder="选择" size="small" style="width: 100%">
                        <el-option v-for="item in aptustwoGvListTrainPlanClassification" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <el-table-column label="训练计划类型" width="150">
                    <template slot="header">
                      <span class="required-field">训练计划类型</span>
                    </template>
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.trainPlanType" multiple placeholder="选择" size="small" style="width: 100%">
                        <el-option v-for="item in aptustwoGvListTrainPlanType" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <el-table-column label="训练计划难度" width="150">
                    <template slot="header">
                      <span class="required-field">训练计划难度</span>
                    </template>
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.trainPlanDifficulty" placeholder="选择" size="small" style="width: 100%">
                        <el-option v-for="item in aptustwoGvListCourseDifficulty" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <el-table-column label="训练计划名称" width="150">
                    <template slot="header">
                      <span class="required-field">训练计划名称</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.trainPlanName" placeholder="必填" size="small"></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="列表封面" width="180">
                    <template slot="header">
                      <span class="required-field">列表封面</span>
                    </template>
                    <template slot-scope="scope">
                      <el-upload
                        class="batch-uploader"
                        :action="''"
                        :http-request="(options) => handleBatchIconUpload(options, scope.$index, 'trainPlanIcon')"
                        :show-file-list="false"
                        :before-upload="beforeImageUpload"
                        :auto-upload="true">
                        <img v-if="scope.row.trainPlanIconUi || scope.row.trainPlanIcon" :src="scope.row.trainPlanIconUi || getImageUrl(scope.row.trainPlanIcon)" class="batch-preview-image">
                        <el-button v-else size="mini" type="primary" icon="el-icon-upload">上传</el-button>
                      </el-upload>
                    </template>
                  </el-table-column>

                  <el-table-column label="详情页封面" width="180">
                    <template slot="header">
                      <span class="required-field">详情页封面</span>
                    </template>
                    <template slot-scope="scope">
                      <el-upload
                        class="batch-uploader"
                        :action="''"
                        :http-request="(options) => handleBatchIconUpload(options, scope.$index, 'trainPlanIconDetails')"
                        :show-file-list="false"
                        :before-upload="beforeImageUpload"
                        :auto-upload="true">
                        <img v-if="scope.row.trainPlanIconDetailsUi || scope.row.trainPlanIconDetails" :src="scope.row.trainPlanIconDetailsUi || getImageUrl(scope.row.trainPlanIconDetails)" class="batch-preview-image">
                        <el-button v-else size="mini" type="primary" icon="el-icon-upload">上传</el-button>
                      </el-upload>
                    </template>
                  </el-table-column>

                  <el-table-column label="Banner封面" width="180">
                    <template slot="header">
                      <span class="required-field">Banner封面</span>
                    </template>
                    <template slot-scope="scope">
                      <el-upload
                        class="batch-uploader"
                        :action="''"
                        :http-request="(options) => handleBatchIconUpload(options, scope.$index, 'trainPlanIconBanner')"
                        :show-file-list="false"
                        :before-upload="beforeImageUpload"
                        :auto-upload="true">
                        <img v-if="scope.row.trainPlanIconBannerUi || scope.row.trainPlanIconBanner" :src="scope.row.trainPlanIconBannerUi || getImageUrl(scope.row.trainPlanIconBanner)" class="batch-preview-image">
                        <el-button v-else size="mini" type="primary" icon="el-icon-upload">上传</el-button>
                      </el-upload>
                    </template>
                  </el-table-column>

                  <el-table-column label="每周训练次数" width="120">
                    <template slot="header">
                      <span class="required-field">每周训练次数</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.trainPlanWeekNum" placeholder="次" size="small" type="number"></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="训练计划时长(分钟)" width="140">
                    <template slot="header">
                      <span class="required-field">训练计划时长(分钟)</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.trainPlanTime" placeholder="分钟" size="small" type="number"></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="训练计划简介" width="150">
                    <template slot="header">
                      <span class="required-field">训练计划简介</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.trainPlanInfo" placeholder="训练计划简介" size="small" type="textarea" :rows="2"></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="首页推荐" width="120">
                    <template slot="header">
                      <span class="required-field">首页推荐</span>
                    </template>
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.isHome" placeholder="选择" size="small" style="width: 100%">
                        <el-option label="否" value="0"></el-option>
                        <el-option label="是" value="1"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <el-table-column label="Banner推荐" width="120">
                    <template slot="header">
                      <span class="required-field">Banner推荐</span>
                    </template>
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.isBanner" placeholder="选择" size="small" style="width: 100%">
                        <el-option label="否" value="0"></el-option>
                        <el-option label="是" value="1"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <el-table-column label="推荐标题" width="150">
                    <template slot="header">
                      <span class="required-field">推荐标题</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.bannerTitle" placeholder="推荐标题" size="small"></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="推荐描述" width="150">
                    <template slot="header">
                      <span class="required-field">推荐描述</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.bannerDescription" placeholder="推荐描述" size="small" type="textarea" :rows="2"></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" width="80" fixed="right" align="center">
                    <template slot-scope="scope">
                      <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deleteBatchRow(scope.$index)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button type="success" @click="saveBatchData" :loading="batchLoading" icon="el-icon-check">保存全部</el-button>
                <el-button @click="dialogBatchAdd = false">取 消</el-button>
              </div>
            </el-dialog>
            <!-- 批量新增弹窗 End -->

          </div>
      </el-tab-pane>

      <!-- 安排每周训练日程 start -->
      <el-tab-pane :label="TabSecondTitle" name="second">
        <WebTwoTrainPlanDatabaseSub ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></WebTwoTrainPlanDatabaseSub>
      </el-tab-pane>
      <!-- 安排每周训练日程 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import UploadExcel from '../components/UploadExcel.vue'
import WebTwoTrainPlanDatabaseSub from '@/componentsSubVue/WebTwoTrainPlanDatabaseSub.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    UploadExcel,
    WebTwoTrainPlanDatabaseSub
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      aptustwoGvListCourseType:[],
      aptustwoGvListCourseDifficulty:[],
      aptustwoGvListCourseTimeType:[],
      aptustwoGvListBodyType:[],
      aptustwoGvListMuscleRoup:[],
      aptustwoGvListAccessories:[],
      aptustwoGvListTrainPlanClassification:[],
      aptustwoGvListTrainPlanType:[],
      queryData: {
        trainPlanClassification: '0',
        trainPlanName: '',
        trainPlanDifficulty: '0',
        trainPlanType: '0',
        isHome: '-1',
        isBanner: '-1'
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      // 新增
      dialogAdd: false,
      addData: {
        trainPlanClassification: '2',
        trainPlanWeekNum: '0',
        trainPlanTime: '0',
        trainPlanName: '',
        trainPlanIcon: '',
        trainPlanIconUi: '',
        trainPlanIconDetails: '',
        trainPlanIconDetailsUi: '',
        trainPlanIconBanner: '',
        trainPlanIconBannerUi: '',
        trainPlanDifficulty: '',
        trainPlanType: [],
        trainPlanInfo: '',
        isHome: '0',
        isBanner: '0',
        bannerTitle: '',
        bannerDescription: ''
      },
      uploadAction: Vue.prototype.global.Url_Base + 'Upload/file',
      uploadLoading: false,
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        trainPlanWeekNum: '0',
        trainPlanTime: '0',
        trainPlanName: '',
        trainPlanIcon: '',
        trainPlanIconUi: '',
        trainPlanIconDetails: '',
        trainPlanIconDetailsUi: '',
        trainPlanIconBanner: '',
        trainPlanIconBannerUi: '',
        trainPlanDifficulty: '',
        trainPlanType: [],
        trainPlanInfo: '',
        isHome: '0',
        isBanner: '0',
        bannerTitle: '',
        bannerDescription: ''
      },
      // 删除
      deleteForm: {
        id: ''
      },
      dialogDel: false,
      allowChangeTab: false,
      TabSecondTitle:'安排周日程',
      // 批量新增
      dialogBatchAdd: false,
      batchData: [],
      batchLoading: false
    }
  },
  mounted () {
    this.aptustwoGvListCourseType = JSON.parse(localStorage.getItem('aptustwoGvListCourseType'));
    this.aptustwoGvListCourseDifficulty = JSON.parse(localStorage.getItem('aptustwoGvListCourseDifficulty'));
    this.aptustwoGvListCourseTimeType = JSON.parse(localStorage.getItem('aptustwoGvListCourseTimeType'));
    this.aptustwoGvListBodyType = JSON.parse(localStorage.getItem('aptustwoGvListBodyType'));
    this.aptustwoGvListMuscleRoup = JSON.parse(localStorage.getItem('aptustwoGvListMuscleRoup'));
    this.aptustwoGvListAccessories = JSON.parse(localStorage.getItem('aptustwoGvListAccessories'));
    this.aptustwoGvListTrainPlanClassification = JSON.parse(localStorage.getItem('aptustwoGvListTrainPlanClassification'));
    this.aptustwoGvListTrainPlanType = JSON.parse(localStorage.getItem('aptustwoGvListTrainPlanType'));
    this.TrainPlanDatabaseList()
    this.TrainPlanDatabaseNum()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.TabSecondTitle = '安排周日程'
      this.TrainPlanDatabaseList()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.TrainPlanDatabaseList()
      this.TrainPlanDatabaseNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.TrainPlanDatabaseList()
      this.TrainPlanDatabaseNum()
    },
    beforeTabLeave(activeName, oldActiveName) {
      if (!this.allowChangeTab && activeName !== "first") {
        this.$message.warning('禁止点击');
        return false;
      }
      this.allowChangeTab = false;
      return true;
    },
    clickQuery () {
      this.page_no = 1
      this.TrainPlanDatabaseList()
      this.TrainPlanDatabaseNum()
    },
    clickQueryReset () {
      this.queryData.trainPlanClassification = '0'
      this.queryData.trainPlanName = ''
      this.queryData.trainPlanDifficulty = '0'
      this.queryData.trainPlanType = '0'
      this.queryData.isHome = '-1'
      this.queryData.isBanner = '-1'
      this.clickQuery()
    },
    clickdialogAdd () {
      this.dialogAdd = true
      this.addData.trainPlanClassification = '2'
      this.addData.trainPlanWeekNum = '0'
      this.addData.trainPlanTime = '0'
      this.addData.trainPlanName = ''
      this.addData.trainPlanIcon = ''
      this.addData.trainPlanIconUi = ''
      this.addData.trainPlanIconDetails = ''
      this.addData.trainPlanIconDetailsUi = ''
      this.addData.trainPlanIconBanner = ''
      this.addData.trainPlanIconBannerUi = ''
      this.addData.trainPlanDifficulty = ''
      this.addData.trainPlanType = []
      this.addData.trainPlanInfo = ''
      this.addData.isHome = '0'
      this.addData.isBanner = '0'
      this.addData.bannerTitle = ''
      this.addData.bannerDescription = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.trainPlanWeekNum = row.trainPlanWeekNum
      this.editData.trainPlanTime = row.trainPlanTime
      this.editData.trainPlanName = row.trainPlanName
      this.editData.trainPlanIcon = row.trainPlanIcon
      this.editData.trainPlanIconUi = row.trainPlanIconUi
      this.editData.trainPlanIconDetails = row.trainPlanIconDetails
      this.editData.trainPlanIconDetailsUi = row.trainPlanIconDetailsUi
      this.editData.trainPlanIconBanner = row.trainPlanIconBanner
      this.editData.trainPlanIconBannerUi = row.trainPlanIconBannerUi
      this.editData.trainPlanDifficulty = row.trainPlanDifficulty.toString()
      this.editData.trainPlanType = Vue.prototype.ConvertStringToArray(row.trainPlanType)
      this.editData.trainPlanInfo = row.trainPlanInfo
      this.editData.isHome = row.isHome.toString()
      this.editData.isBanner = row.isBanner.toString()
      this.editData.bannerTitle = row.bannerTitle
      this.editData.bannerDescription = row.bannerDescription
    },
    ClickDelete (row) {
      this.dialogDel = true
      this.deleteForm.id = row.id
    },
    gotoWebTwoTrainPlanDatabaseSub(row){
      this.activeName = 'second'
      this.allowChangeTab = true;
      this.TabSecondTitle = '安排周日程-【'+row.trainPlanName+'】'
      this.$refs.SubVuesecond.LoadData(row)
    },
    changeUploadExcel (response) {
      console.log(response)
      Vue.prototype.FunRemindOnlyError(response)
      if (response.code === 1) {
        Vue.prototype.FunRemindAllways(response.data)
        this.TrainPlanDatabaseList()
        this.TrainPlanDatabaseNum()
      }
    },
    TrainPlanDatabaseList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainPlanClassification = that.queryData.trainPlanClassification
      data.trainPlanName = that.queryData.trainPlanName
      data.trainPlanDifficulty = that.queryData.trainPlanDifficulty
      data.trainPlanType = that.queryData.trainPlanType
      data.isHome = that.queryData.isHome
      data.isBanner = that.queryData.isBanner
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainPlanDatabaseNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainPlanClassification = that.queryData.trainPlanClassification
      data.trainPlanName = that.queryData.trainPlanName
      data.trainPlanDifficulty = that.queryData.trainPlanDifficulty
      data.trainPlanType = that.queryData.trainPlanType
      data.isHome = that.queryData.isHome
      data.isBanner = that.queryData.isBanner
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainPlanDatabaseInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainPlanClassification = that.addData.trainPlanClassification
      data.trainPlanWeekNum = that.addData.trainPlanWeekNum
      data.trainPlanTime = that.addData.trainPlanTime
      data.trainPlanName = that.addData.trainPlanName
      data.trainPlanIcon = that.addData.trainPlanIcon
      data.trainPlanIconDetails = that.addData.trainPlanIconDetails
      data.trainPlanIconBanner = that.addData.trainPlanIconBanner
      data.trainPlanDifficulty = that.addData.trainPlanDifficulty
      data.trainPlanType = Vue.prototype.ConvertArrayToString(that.addData.trainPlanType)
      data.trainPlanInfo = that.addData.trainPlanInfo
      data.isHome = that.addData.isHome
      data.isBanner = that.addData.isBanner
      data.bannerTitle = that.addData.bannerTitle
      data.bannerDescription = that.addData.bannerDescription
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.TrainPlanDatabaseList()
            that.TrainPlanDatabaseNum()
            that.dialogAdd = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAdd = false
        })
    },
    TrainPlanDatabaseUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.trainPlanWeekNum = that.editData.trainPlanWeekNum
      data.trainPlanTime = that.editData.trainPlanTime
      data.trainPlanName = that.editData.trainPlanName
      data.trainPlanIcon = that.editData.trainPlanIcon
      data.trainPlanIconDetails = that.editData.trainPlanIconDetails
      data.trainPlanIconBanner = that.editData.trainPlanIconBanner
      data.trainPlanDifficulty = that.editData.trainPlanDifficulty
      data.trainPlanType = Vue.prototype.ConvertArrayToString(that.editData.trainPlanType)
      data.trainPlanInfo = that.editData.trainPlanInfo
      data.isHome = that.editData.isHome
      data.isBanner = that.editData.isBanner
      data.bannerTitle = that.editData.bannerTitle
      data.bannerDescription = that.editData.bannerDescription
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.TrainPlanDatabaseList()
            that.TrainPlanDatabaseNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    TrainPlanDatabaseDelete: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.deleteForm.id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.TrainPlanDatabaseList()
            that.TrainPlanDatabaseNum()
          }
          that.dialogDel = false
        })
        .catch(function (error) {
          console.log(error)
          that.dialogDel = false
        })
    },
    // 图片上传前校验
    beforeImageUpload (file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    // 新增-列表封面上传
    handleAddTrainPlanIconUpload (options) {
      this.handleFileUpload(options, 'add', 'trainPlanIcon', 'images/trainplan/')
    },
    // 新增-详情页封面上传
    handleAddTrainPlanIconDetailsUpload (options) {
      this.handleFileUpload(options, 'add', 'trainPlanIconDetails', 'images/trainplan/')
    },
    // 新增-Banner封面上传
    handleAddTrainPlanIconBannerUpload (options) {
      this.handleFileUpload(options, 'add', 'trainPlanIconBanner', 'images/trainplan/')
    },
    // 编辑-列表封面上传
    handleEditTrainPlanIconUpload (options) {
      this.handleFileUpload(options, 'edit', 'trainPlanIcon', 'images/trainplan/')
    },
    // 编辑-详情页封面上传
    handleEditTrainPlanIconDetailsUpload (options) {
      this.handleFileUpload(options, 'edit', 'trainPlanIconDetails', 'images/trainplan/')
    },
    // 编辑-Banner封面上传
    handleEditTrainPlanIconBannerUpload (options) {
      this.handleFileUpload(options, 'edit', 'trainPlanIconBanner', 'images/trainplan/')
    },
    // 通用文件上传处理
    handleFileUpload (options, type, field, category) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()
      
      // 显示 loading
      that.uploadLoading = true
      
      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data)
      
      // 签名后再添加type参数（type不参与签名计算）
      data.type = 'ajax'
      
      // 添加文件
      formData.append('file', options.file)
      
      // 添加其他参数
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      formData.append('category', category)
      
      // 使用axios手动上传
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        that.uploadLoading = false
        if (response.data.code === 1) {
          // 使用返回的absoluteUrl，无需手动拼接URL
          const targetData = type === 'add' ? that.addData : that.editData
          const uiField = field + 'Ui'
          // 使用$set确保响应式更新
          that.$set(targetData, field, response.data.data.relativeUrl)
          that.$set(targetData, uiField, response.data.data.absoluteUrl)
          that.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          that.$message.error('上传失败：' + response.data.message)
          options.onError(response.data)
        }
      }).catch(function (error) {
        that.uploadLoading = false
        console.log(error)
        that.$message.error('上传失败！')
        options.onError(error)
      })
    },
    // 图片URL处理
    getImageUrl (url) {
      if (!url) return ''
      // 如果已经是完整的URL(http://或https://开头),直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      // 兼容历史数据：如果是相对路径，拼接基础URL
      return Vue.prototype.global.Url_Base + url
    },
    // 批量新增 - 打开弹窗
    clickBatchAdd () {
      this.dialogBatchAdd = true
      // 默认添加一行
      if (this.batchData.length === 0) {
        this.addBatchRow()
      }
    },
    // 批量新增 - 添加一行
    addBatchRow () {
      this.batchData.push({
        trainPlanClassification: '2',
        trainPlanType: [],
        trainPlanDifficulty: '',
        trainPlanName: '',
        trainPlanIcon: '',
        trainPlanIconUi: '',
        trainPlanIconDetails: '',
        trainPlanIconDetailsUi: '',
        trainPlanIconBanner: '',
        trainPlanIconBannerUi: '',
        trainPlanWeekNum: '0',
        trainPlanTime: '0',
        trainPlanInfo: '',
        isHome: '0',
        isBanner: '0',
        bannerTitle: '',
        bannerDescription: ''
      })
    },
    // 批量新增 - 删除一行
    deleteBatchRow (index) {
      this.$confirm('确定删除该行数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchData.splice(index, 1)
        this.$message.success('删除成功')
      }).catch(() => {})
    },
    // 批量新增 - 清空
    clearBatchData () {
      this.$confirm('确定清空所有数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchData = []
        this.$message.success('清空成功')
      }).catch(() => {})
    },
    // 批量新增 - 图片上传
    handleBatchIconUpload (options, index, field) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()

      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data)

      // 签名后再添加type参数（type不参与签名计算）
      data.type = 'ajax'

      // 添加文件
      formData.append('file', options.file)

      // 添加其他参数
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      formData.append('category', 'images/trainplan/')

      // 使用axios手动上传
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          const uiField = field + 'Ui'
          // 同时更新原字段和Ui字段
          that.batchData[index][field] = response.data.data.relativeUrl
          that.batchData[index][uiField] = response.data.data.absoluteUrl
          that.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          that.$message.error('上传失败：' + response.data.message)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        that.$message.error('上传失败！')
        options.onError(error)
      })
    },
    // 批量新增 - 保存数据
    saveBatchData () {
      var that = this

      if (that.batchData.length === 0) {
        that.$message.warning('请至少添加一行数据')
        return
      }

      // 验证必填字段
      for (let i = 0; i < that.batchData.length; i++) {
        const row = that.batchData[i]
        const rowNum = i + 1

        // 训练计划分类
        if (!row.trainPlanClassification) {
          that.$message.error(`第 ${rowNum} 行：请选择训练计划分类`)
          return
        }

        // 训练计划类型
        if (!row.trainPlanType || row.trainPlanType.length === 0) {
          that.$message.error(`第 ${rowNum} 行：请选择训练计划类型`)
          return
        }

        // 训练计划难度
        if (!row.trainPlanDifficulty) {
          that.$message.error(`第 ${rowNum} 行：请选择训练计划难度`)
          return
        }

        // 训练计划名称
        if (!row.trainPlanName || row.trainPlanName.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：训练计划名称不能为空`)
          return
        }

        // 列表封面
        if (!row.trainPlanIcon || row.trainPlanIcon.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请上传列表封面`)
          return
        }

        // 详情页封面
        if (!row.trainPlanIconDetails || row.trainPlanIconDetails.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请上传详情页封面`)
          return
        }

        // Banner封面
        if (!row.trainPlanIconBanner || row.trainPlanIconBanner.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请上传Banner封面`)
          return
        }

        // 每周训练次数
        if (!row.trainPlanWeekNum || row.trainPlanWeekNum === '' || row.trainPlanWeekNum <= 0) {
          that.$message.error(`第 ${rowNum} 行：请输入有效的每周训练次数`)
          return
        }

        // 训练计划时长
        if (!row.trainPlanTime || row.trainPlanTime === '' || row.trainPlanTime <= 0) {
          that.$message.error(`第 ${rowNum} 行：请输入有效的训练计划时长`)
          return
        }

        // 训练计划简介
        if (!row.trainPlanInfo || row.trainPlanInfo.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请输入训练计划简介`)
          return
        }

        // 首页推荐
        if (row.isHome === undefined || row.isHome === null) {
          that.$message.error(`第 ${rowNum} 行：请选择首页推荐`)
          return
        }

        // Banner推荐
        if (row.isBanner === undefined || row.isBanner === null) {
          that.$message.error(`第 ${rowNum} 行：请选择Banner推荐`)
          return
        }

        // 推荐标题
        if (!row.bannerTitle || row.bannerTitle.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请输入推荐标题`)
          return
        }

        // 推荐描述
        if (!row.bannerDescription || row.bannerDescription.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请输入推荐描述`)
          return
        }
      }

      // 构建请求数据
      const trainPlanList = that.batchData.map(row => {
        return {
          trainPlanClassification: parseInt(row.trainPlanClassification) || 0,
          trainPlanType: Vue.prototype.ConvertArrayToString(row.trainPlanType),
          trainPlanDifficulty: parseInt(row.trainPlanDifficulty) || 0,
          trainPlanName: row.trainPlanName,
          trainPlanIcon: row.trainPlanIcon,
          trainPlanIconDetails: row.trainPlanIconDetails,
          trainPlanIconBanner: row.trainPlanIconBanner,
          trainPlanWeekNum: parseInt(row.trainPlanWeekNum) || 0,
          trainPlanTime: parseInt(row.trainPlanTime) || 0,
          trainPlanInfo: row.trainPlanInfo,
          isHome: parseInt(row.isHome) || 0,
          isBanner: parseInt(row.isBanner) || 0,
          bannerTitle: row.bannerTitle,
          bannerDescription: row.bannerDescription
        }
      })

      that.batchLoading = true

      // 构建请求体
      const requestBody = {
        tempUuid: localStorage.getItem('tempUuid'),
        trainPlanList: trainPlanList
      }

      // 打印请求数据用于调试
      console.log('=== 批量新增请求信息 ===')
      console.log('tempUuid:', requestBody.tempUuid)
      console.log('trainPlanList长度:', trainPlanList.length)
      console.log('完整请求体:', JSON.stringify(requestBody, null, 2))

      // 使用 JSON 格式发送
      axios.post(Vue.prototype.global.Url_Base + 'TrainPlanDatabase/batchInsert', requestBody, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        that.batchLoading = false
        if (response.data.code === 1) {
          that.$message.success('批量新增成功！共 ' + that.batchData.length + ' 条数据')
          that.dialogBatchAdd = false
          that.batchData = []
          that.TrainPlanDatabaseList()
          that.TrainPlanDatabaseNum()
        } else {
          that.$message.error('批量新增失败：' + response.data.message)
        }
      }).catch(function (error) {
        that.batchLoading = false
        console.log(error)
        that.$message.error('批量新增失败！')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-top: 15px;

  .search-content {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    align-items: center;
  }

  .el-input {
    width: 150px;
  }

  .el-select{
    width: 150px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;

    .search-content {
      gap: 10px;
    }

    .el-input {
      width: 120px;
    }

    .el-select{
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
  max-height: 60vh;
  overflow-y: auto;
}

// 表格横向滚动容器
.table-container {
  width: 100%;
  overflow-x: auto;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}

// 上传组件样式
.cover-uploader {
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: #409EFF;
  }
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover-image {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

// 批量新增弹窗样式
.batch-dialog {
  /deep/ .el-dialog__header {
    padding: 15px 20px;
    background: #f6f6fa;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    height: calc(100vh - 130px);
    overflow: hidden;
  }

  /deep/ .el-dialog__footer {
    padding: 15px 20px;
    text-align: center;
    border-top: 1px solid #f2f2f2;
  }
}

// 批量新增样式
.batch-add-container {
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.batch-toolbar {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  .batch-tip {
    color: #909399;
    font-size: 14px;
    margin-left: 20px;
  }
}

.batch-table {
  flex: 1;

  /deep/ .el-table__body-wrapper {
    overflow-x: auto;
  }

  /deep/ .el-input__inner {
    padding: 5px 10px;
  }

  /deep/ .el-textarea__inner {
    padding: 5px 10px;
    min-height: 50px !important;
  }

  /deep/ .el-select {
    width: 100%;
  }
}

// 批量上传组件样式
.batch-uploader {
  /deep/ .el-upload {
    display: block;
    text-align: center;
  }
}

.batch-preview-image {
  width: 60px;
  height: 60px;
  display: block;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
  margin: 0 auto;
}

// 必填字段标记
.required-field {
  &::before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }
}
</style>
